export const base_path = "/react/template/";
export const image_path = '/react/template/'
export const google_maps_api_key = import.meta.env['VITE_GOOGLE_MAPS_API_KEY'] || "AIzaSyD6adZVdzTvBpE2yBRK8cDfsss8QXChK0I";
